export default __webpack_public_path__ + "static/media/LOGO_2.53914a39.svg";